import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { useTranslation } from "react-i18next";

interface Props {
  showRisks: boolean;
  phoneNumber?: string;
  address?: string;
  city?: string;
  postcode?: string;
  country?: string;
  riskList?: string[];
}

function ContactAndAddress({ showRisks, phoneNumber, address, city, postcode, country, riskList = [] }: Props) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      {phoneNumber && (
        <SummaryRow
          key="phone-number"
          label={t('forms.visa:phoneNumber')}
          value={phoneNumber}
          isRisk={showRisks && riskList.includes(Q.PHONE_NUMBER)}
        />
      )}
      {address && (
        <SummaryRow
          key="address"
          label={t('forms.visa:permanentResidentialAddress')}
          value={address}
          isRisk={showRisks && riskList.includes(Q.HOME_ADDRESS)}
        />
      )}
      {city && <SummaryRow key="city" label={t('forms.visa:city')} value={city} isRisk={showRisks && riskList.includes(Q.CITY)} />}
      {postcode && (
        <SummaryRow
          key="postcode"
          label={t('forms.visa:postcode')}
          value={postcode}
          isRisk={showRisks && riskList.includes(Q.POSTCODE)}
        />
      )}
      {country && (
        <SummaryRow key="country" label={t('forms.visa:country')} value={country} isRisk={showRisks && riskList.includes(Q.COUNTRY)} />
      )}
    </>
  );
}

export default ContactAndAddress;
